import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { GoogleLogo } from './GoogleLogo';
import type { ChristmasReview } from '../../../data/christmasReviews';
type ReviewCardProps = {
  review?: ChristmasReview; // undefined = empty slot awaiting a genuine review
};
function Stars({
  rating
}: {
  rating?: number;
}) {
  const filled = typeof rating === 'number' ? Math.round(rating) : 0;
  return <div className="flex items-center gap-0.5" role="img" aria-label={typeof rating === 'number' ? `${rating} out of 5 stars` : 'Star rating not yet added'} data-id="element-286" data-mp="1wp6kl68sz1sq">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} aria-hidden="true" className={`h-5 w-5 ${i < filled ? 'fill-[#E3B341] text-[#E3B341]' : 'text-forest/20'}`} data-id="element-287" data-mp="1mzd71zp3oclu" data-mpi={i} />)}
    </div>;
}
export function ReviewCard({
  review
}: ReviewCardProps) {
  const isSlot = !review;
  return <div className="flex h-full flex-col rounded-[2rem] bg-cream p-8 ring-1 ring-[#E3C77F]/50 sm:p-10" data-id="element-288" data-mp="18zuam45nippd">
      <div className="flex items-start justify-between gap-4" data-id="element-289" data-mp="3jv69mo66gjyw">
        <QuoteIcon className="h-9 w-9 text-[#E3C77F]" aria-hidden="true" data-id="element-290" data-mp="3onhdg241gpwq" />
        <Stars rating={review?.rating} data-id="element-291" data-mp="3aw2shpqkmen1" />
      </div>

      <blockquote className={`mt-6 flex-1 font-display text-xl leading-relaxed sm:text-2xl ${isSlot ? 'italic text-forest/45' : 'text-forest'}`} data-id="element-292" data-mp="3axdr7b55sw7a">
        {isSlot ? 'This space is reserved for a genuine review from a Chacon’s Lawncare Christmas lighting customer.' : `“${review.text}”`}
      </blockquote>

      <div className="mt-8 flex flex-wrap items-end justify-between gap-4 border-t border-forest/10 pt-6" data-id="element-293" data-mp="3tmkgxi4deo2l">
        <div data-id="element-294" data-mp="2fr8bt78zmo1">
          <p className={`font-semibold ${isSlot ? 'text-forest/45' : 'text-forest'}`} data-id="element-295" data-mp="2f7x0vc3rwiz">
            {isSlot ? 'Customer Name' : review.author}
          </p>
          {isSlot ? <p className="mt-0.5 text-sm text-forest/40" data-id="element-296" data-mp="2n5yq1lp4ckxm">Review date</p> : review.date && <p className="mt-0.5 text-sm text-forest/55" data-id="element-297" data-mp="sqjgfh2qwd9b">{review.date}</p>}
        </div>

        {isSlot ? <span className="rounded-full bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-forest/45 ring-1 ring-forest/10" data-id="element-298" data-mp="nrye9c3xnji8">
            Awaiting review
          </span> : review.source === 'google' ? <div className="flex items-center gap-2 text-sm font-semibold text-forest/70" data-id="element-299" data-mp="eyd302qz8kdk">
            <GoogleLogo data-id="element-300" data-mp="a0tn6yemrzji" />
            {review.url ? <a href={review.url} target="_blank" rel="noopener noreferrer" className="underline-offset-4 hover:text-olive hover:underline" data-id="element-301" data-mp="4zw66p5cxbjl">
                Google Review
              </a> : <span data-id="element-302" data-mp="3s5wyj0v6x7sd">Google Review</span>}
          </div> : review.url && <a href={review.url} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-olive underline-offset-4 hover:underline" data-id="element-303" data-mp="1uec5axdwxm5w">
              View original review
            </a>}
      </div>
    </div>;
}